module.exports = __webpack_public_path__ + "static/media/ic_twitter_menu.ce014edb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/ic_twitter_menu.svg
// module id = 288
// module chunks = 0